import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';
import '../assets/styles/section.css';
/* eslint-disable react/prop-types */
export default function BorderSection({ icon, title, children }) {
  return (
    <div className='mainContainer' style={{ backgroundColor: '#fff' }}>
      <div className='header'>
        <div className='headerBorderBefore' />
        {(icon || title) && (
          <div className='headerTitle'>
            {icon && <SvgIcon component={icon} />}
            {title && <span className='title'>{title}</span>}
          </div>
        )}
        <div className='headerBorderAfter' />
      </div>
      <div className='childrenContainer'>{children}</div>
    </div>
  );
}
